import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import NotFound from "../Pages/PageNotFound";
import "../scss/_soloPage.scss";

function linkify(text) {
    // Regex for detecting emails
    const emailPattern = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    // Regex for detecting URLs
    const urlPattern = /(https?:\/\/[^\s]+)/gi;

    // Replace email with anchor tag
    text = text.replace(emailPattern, "<a href=\"mailto:$1\">$1</a>");
    // Replace URLs with anchor tag
    text = text.replace(urlPattern, "<a href=\"$1\" target=\"_blank\">$1</a>");

    text = text.replace(/\n/g, "<br />");

    return text;
}

function SoloPage() {
    const { i18n } = useTranslation();
    const slides = i18n.getResourceBundle(
        i18n.language,
        "membersTranslationContainer"
    ).membersTranslation;

    const animation = {
        initial: {
            opacity: 0,
            y: 100,
        },
        animate: {
            opacity: 1,
            y: 0,
            transform: "skewY(0deg)",
        },
    };

    const { pageId } = useParams();

    // Convert pageId to a number since `id` is numeric
    const data = slides.find((slide) => slide.id === parseInt(pageId));

    useEffect(() => {
        const element = document.getElementsByClassName("outerContainer")[0];
        element.scrollIntoView();
    }, [pageId]);

    if (!data) {
        return <NotFound />;
    }

    return (
        <>
            {data && (
                <>
                    <div className="person-big">
                        <div className="person-big-name">
                            {data.fName} {data.lName}
                        </div>
                        <div className="person-big-degree">{data.degree}</div>
                    </div>
                    <div className="person-small">
                        <motion.div
                            variants={animation}
                            initial="initial"
                            transition={{
                                delay: 0.45,
                            }}
                            whileInView="animate"
                            viewport={{
                                once: true,
                            }}
                            className="slant-box"
                        >
                            <img
                                className="person-image"
                                alt={data.alt}
                                src={require(`../assets/${data.src}`)}
                            />
                        </motion.div>
                        <div className="person-container-text">
                            <div className="person-container-text-title">
                                About {data.fName}
                            </div>
                            <div
                                className="person-container-text-about"
                                dangerouslySetInnerHTML={{
                                    __html: linkify(data.desc),
                                }}
                            />
                            {/* <div className="person-container-text-about">
                                {data.desc.split("\n").map((item, key) => (
                                    <span key={key}>
                                        {item}
                                        <br />
                                    </span>
                                ))}
                            </div> */}
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default SoloPage;
